"use strict";

// ReactHelper
module.exports = {
	getRoot: function(element, reactDom) {
		reactDom = reactDom || window.ReactDOM;

		element.__reactRoot = element.__reactRoot || reactDom.createRoot(element);

		return element.__reactRoot;
	},

	// Render with flushSync for components that need synchronous DOM updates (jQuery/vanilla JS compatibility)
	render: function(element, component, reactDom) {
		reactDom = reactDom || window.ReactDOM;
		
		var root = this.getRoot(element, reactDom);
		
		// Use flushSync to force synchronous rendering when needed
		reactDom.flushSync(() => {
			root.render(component);
		});
		
		return root;
	},

	// Standard async render for components that don't need immediate DOM availability
	renderAsync: function(element, component, reactDom) {
		var root = this.getRoot(element, reactDom);
		root.render(component);
		return root;
	},

	unmountElement: function (element, reactDom, shouldRecreateRoot) {
		reactDom = reactDom || window.ReactDOM;

		// Check if the component was rendered with React.render
		if (element._reactRootContainer) {
			// If it was rendered with React.render, unmount it in the old style, since
			// using the createRoot method is not supported on that element.
			// See the ReactDOM createRoot function source for more information.
			reactDom.unmountComponentAtNode(element);
		} else {
			var root = element.__reactRoot || reactDom.createRoot(element);
			root.unmount();
		}

		// Clear or recreate the root now that it has been unmounted
		element.__reactRoot = shouldRecreateRoot ? reactDom.createRoot(element) : undefined;

		return element.__reactRoot;
	}
};
